import { makeStyles } from '@material-ui/core/styles';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  toolbar: {
    color: '#fff',
    backgroundColor: '#3f51b5',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    borderRightWidth: 0,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  listItemText: {
    fontSize: 14,
    marginTop: 4,
    marginBottom: 4,
  },
  selected: {
    width: 210,
    borderRadius: theme.spacing(1),
    '&.Mui-selected': {
      backgroundColor: "rgb(238, 242, 246)",
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    backgroundColor: 'rgb(238, 242, 246)',
  },
  footer: {
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    bottom: '10px',
  },
}));

export default useStyles;
